import styled from 'styled-components';

export const InputWrapper = styled.div`
  margin-bottom: 24px;
  width: 100%;
`;

export const InputLabel = styled.label`
  display: block;
  font-size: 16px;
  font-weight: 400;
  color: #1a1a1a;
  margin-bottom: 12px;
  font-family: 'Inter', sans-serif;
`;

export const RequiredAsterisk = styled.span`
  color: #1a1a1a;
  margin-left: 2px;
  font-size: 16px;
`;

export const ErrorMessage = styled.p`
  color: #f73450;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  display: block;
`;

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${(props) => (props.isDisabled ? '#fafafa' : 'white')};
  border: 1.5px solid ${(props) => (props.hasError ? '#f73450' : '#e0e0e0')};
  border-radius: 50px;
  padding: 0 20px;
  transition: all 0.2s ease;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'text')};

  ${(props) =>
    props.isFocused &&
    !props.isDisabled &&
    !props.hasError &&
    `
    border-color: #b0b0b0;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.03);
  `}

  ${(props) =>
    props.hasError &&
    `
    border-color: #f73450;
    box-shadow: 0 0 0 3px rgba(247, 52, 80, 0.1);
  `}
`;

export const InputIcon = styled.span`
  display: flex;
  align-items: center;
  margin-right: 12px;
  color: ${(props) => (props.isDisabled ? '#999' : '#666')};
  font-size: 20px;
`;

export const InputField = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  color: #1a1a1a;
  background-color: transparent;
  padding: 0.8em 0;
  font-weight: 400;
  font-family: 'Inter', sans-serif;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'text')};

  &::placeholder {
    color: #999;
  }

  &:disabled {
    color: #999;
    cursor: not-allowed;
  }
`;
